{
  "load_failed": "Kyselytietojen lataus epäonnistui",
  "not_enabled": "Kyselyt eivät ole käytössä tällä seuralla",
  "prompt": {
    "kicker": "Kentän kysely",
    "title": "Anna palautetta kentästä",
    "round_meta": "Kierros {{date}}",
    "boolean_true": "Kyllä",
    "boolean_false": "Ei",
    "scale_low": "Heikko",
    "scale_high": "Erinomainen",
    "comment_label": "Kommentti (valinnainen)",
    "comment_placeholder": "Kerro lisää...",
    "submit": "Lähetä",
    "skip": "Ohita",
    "submitted": "Kiitos palautteesta!",
    "submit_failed": "Palautteen lähetys epäonnistui"
  },
  "editor": {
    "page_title": "Kentän kyselyt",
    "select_course": "Valitse kenttä",
    "no_courses": "Ei kenttiä",
    "course_section": "Kenttä",
    "poll_section": "Kysely",
    "chip_locked": "Lukittu",
    "responses_label": "vastausta",
    "questions_count_label": "kysymystä",
    "edit_questions": "Muokkaa kysymyksiä",
    "locked_micro": "Kysymykset lukittuivat ensimmäisestä vastauksesta. Korvaa kysely, jos haluat muuttaa niitä.",
    "frequency_label": "Kysymystiheys",
    "frequency": {
      "AFTER_EACH_ROUND": "Jokaisen kierroksen jälkeen",
      "WEEKLY": "Kerran viikossa",
      "MONTHLY": "Kerran kuukaudessa",
      "ANNUAL": "Kerran vuodessa"
    },
    "questions_label": "Kysymykset",
    "question_text_placeholder": "Kirjoita kysymys",
    "question_type_label": "Tyyppi",
    "question_type": {
      "BOOLEAN": "Kyllä/Ei",
      "SCALE": "Asteikko 1-5"
    },
    "add_question": "Lisää kysymys",
    "remove_question": "Poista kysymys",
    "move_up": "Siirrä ylös",
    "move_down": "Siirrä alas",
    "fill_all_questions": "Kirjoita teksti jokaiseen kysymykseen",
    "create_button": "Luo kysely",
    "save_button": "Tallenna muutokset",
    "replace_button": "Korvaa kysely",
    "replace_save_button": "Tallenna uusi kysely",
    "cancel_replace": "Peruuta",
    "archive_button": "Arkistoi kysely",
    "locked_notice": "Kyselyyn on tullut vastauksia, joten kysymyksiä ei voi enää muokata. Korvaa kysely, jos haluat muuttaa kysymyksiä.",
    "no_active_poll": "Kentällä ei ole aktiivista kyselyä.",
    "created": "Kysely luotu",
    "updated": "Kysely päivitetty",
    "replaced": "Kysely korvattu",
    "archived": "Kysely arkistoitu",
    "archive_confirm_header": "Arkistoi kysely",
    "archive_confirm_button": "Arkistoi",
    "archive_confirm_body": "Haluatko varmasti arkistoida kyselyn? Kentällä ei tämän jälkeen ole aktiivista kyselyä ennen kuin luot uuden.",
    "response_count": "{{count}} vastausta",
    "status_active": "Aktiivinen"
  },
  "results": {
    "title": "Tulokset",
    "answered_yes": "Vastasi kyllä",
    "no_responses": "Ei vastauksia",
    "average": "Keskiarvo",
    "median": "Mediaani",
    "distribution_title": "Jakauma",
    "trend_title": "Kehitys kuukausittain",
    "no_comments": "Ei kommentteja"
  },
  "report": {
    "kicker": "Kentän kysely · Tulokset",
    "kicker_questions": "Kentän kysely · Kysymykset",
    "kicker_new": "Kentän kysely · Uusi kysely",
    "period_label": "Jakso",
    "comments_stat": "kommenttia",
    "overall_average": "kokonaiskeskiarvo",
    "n_count": "n={{count}}",
    "med_tick": "Med {{value}}",
    "vs_month": "vs. {{month}}",
    "pp_value": "{{value}} pp",
    "yes_no_label": "kyllä / ei",
    "open_feedback": "Avoin palaute",
    "comments_count": "{{count}} kommenttia",
    "export_pdf": "Lataa PDF",
    "pdf_title": "Kentän kysely",
    "pdf_page": "Sivu {{page}} / {{pages}}"
  },
  "history": {
    "archive_section": "Arkisto",
    "empty": "Ei arkistoituja kyselyitä",
    "archived": "Arkistoitu"
  }
}
